

import { useEffect, useState } from "react";

import liff from "@line/liff";
import { CURRENT_ENV } from "../../Utills/constants";
import axios from "axios";
import LoadingScreen from "../Loading/LoadingScreen";
import game from "../../Images/gacha12.png"; //Change Version

function Theme12Screen() {
  const [profileLine, setProfileLine] = useState();
  const [data, setData] = useState(null);
  const [listRewards, setListRewards] = useState(null);
  const [rewards, setRewards] = useState(null);

  const [isShaking, setIsShaking] = useState(false);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    liff
      .init({
        liffId: CURRENT_ENV.LIFF_ID12,  //Change Version
      })
      .then(async () => {
        if (liff.isLoggedIn()) {
          liff
            .getProfile()
            .then((profile) => {
              console.log("%cPROFILE LINEOA : ", "color: green", profile);
              setProfileLine(profile.userId);
            })
            .catch((err) => {
              console.log("%cERROR LINEOA DETAIL", "color: red", err);
            });
        } else {
          liff.login();
        }
      })
      .catch((err) => {
        console.log(
          "%cERROR LINEOA HEADER",
          "color: red",
          err.code,
          err.message
        );
      });
    return () => { };
  }, []);

  useEffect(() => {
    const fetchData = async () => {

      if (profileLine) {
        try {
          const response = await axios.get(`${CURRENT_ENV.API_BASE_URL12}?path=getData&userId=${profileLine}`); //Change Version
          if (response.data.status === 200) {
            setData(response.data.data) 
          }
        } catch (_) { }
        finally {
          setLoading(false)
        }
      }
    };
    fetchData();

  }, [profileLine]);

  useEffect(() => {
    const fetchRewards = async () => {
      try {
        const response = await axios.get(`${CURRENT_ENV.API_BASE_URL12}?path=getRewards`); //Change Version
        if (response.data.status === 200) {
          setListRewards(response.data.data)
        }
      } catch (_) { }
      finally {
        // setLoading(false)
      }
    };
    fetchRewards();

  }, []);

  const randomRewards = async () => {
    try {
      setIsShaking(true);
      setLoading(true)
      setRewards(null)
      const response = await axios.get(`${CURRENT_ENV.API_BASE_URL12}?path=play&userId=${profileLine}`); //Change Version
      if (response.data.status === 200) {
        setRewards(response.data)
        liff
          .sendMessages([
            {
              "type": "flex",
              "altText": `ยินดีด้วยคุณได้รับรางวัล คลิกเพื่อดู`,
              "contents": {
                "type": "bubble",
                "hero": {
                  "type": "image",
                  "url": CURRENT_ENV.FLEX_IMAGE12, //Change Version
                  "size": "full",
                  "aspectRatio": "20:13",
                  "aspectMode": "cover"
                },
                "body": {
                  "type": "box",
                  "layout": "vertical",
                  "contents": [
                    {
                      "type": "text",
                      "text": "แทนคำขอบคุณในเดือนมีนาคม",
                      "weight": "bold",
                      "size": "xl"
                    },
                    {
                      "type": "box",
                      "layout": "vertical",
                      "contents": [
                        {
                          "type": "text",
                          "text": `ยินดีด้วยคุณได้รับ ${response.data.reward.name}`,
                          "size": "lg",
                          "color": "#B3B3B3",
                          "wrap": true
                        }
                      ]
                    }
                  ]
                }
              }
            }
          ])
          .then(() => {
            window.alert("ส่งรางวัลไปยังช่องแชทเรียบร้อยค่ะ")
          })
          .catch((err) => {
            console.log("error", err);
          });
      } else if (response.data.status === 204) {
        window.alert(response.data.message)
      }
    } catch (_) { }
    finally {
      setIsShaking(false)
      setLoading(false)
    }
  };

  return (
    <>
      {
        loading ?
          <LoadingScreen />
          : null

      }
      <div>
        <div className="container app-bg12"> {/*  Change Version */}
          <div>
            <div>
              <h1 className="txt-title">สุ่มกาชาปอง 99฿<br/>ลุ้นรางวัลใหญ่</h1>
            </div>
            <div>
              {
                data?.value >= data?.total || rewards?.data?.value >= rewards?.data?.total ?
                  <img src={game} alt="" className="reward-image" style={{ opacity: 0.5 }} />
                  :
                  <img onClick={() => { randomRewards() }} src={game} alt="" className={`reward-image ${isShaking ? "shake" : ""}`} />
              }

            </div>
            {
              rewards ?
                <div>
                  <div style={{ display: `flex`, flexDirection: `row`, backgroundColor: `#ffffff94`, borderRadius: 20, justifyContent: `center`, alignContent: `center`, overflow: `scroll`, padding: 10, fontSize: 20, fontWeight: `bold`, border: `3px solid #9bff15` }}>
                    คุณได้รับ : {rewards?.reward?.name}
                  </div>
                </div>
                : null
            }

            {
              data?.value >= data?.total ?
                <div>
                  <div style={{ display: `flex`, flexDirection: `row`, backgroundColor: `#ffffff94`, borderRadius: 20, justifyContent: `center`, alignContent: `center`, overflow: `scroll`, padding: 10, fontSize: 20, fontWeight: `bold`, border: `3px solid red` }}>
                    ขออภัย คุณใช้สิทธิ์สุ่มรางวัลครบแล้ว!
                  </div>
                </div>
                : null
            }

            {
              listRewards ?
                <div style={{marginTop: -50}}>
                  <h2 className="txt-title">ของรางวัล</h2>
                  <div style={{display: `flex`, justifyContent: `center`, padding: 10, overflow: `scroll`, height: 200}}>
                    <div style={{ display: `grid`, width: `100%` }}>
                      <div className="grid-container">
                        {
                          listRewards?.map((data, index) => (
                            <div key={index}>
                              <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, flexDirection: `column`, margin: 2, fontSize: 12 }}>
                                <img src={data.image} alt="" style={{ width: 30 }} />
                                <div>
                                {data.name}
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  </div>
                </div> : null
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default Theme12Screen;
